import { Action, createReducer, on } from "@ngrx/store";
import { Questionnaire } from "../../models/open/questionnaire.model";
import { initialState, QuestionnaireState } from "../../states/open/states";
import * as QuestionnaireAction from "../../actions/open/questionnaire.actions";
import { NumberValueAccessor } from "@angular/forms";
import { PagesRoutingModule } from "src/app/pages/pages-routing.module";

export const ADD_QUESTIONNAIRE = "ADD_QUESTIONNAIRE";
export const UPDATE_QUESTIONNAIRE = "UPDATE_QUESTIONNAIRE";

export const questionnaireReducer = createReducer(
	initialState,
	on(QuestionnaireAction.addQuestionnaire, (state, action) => {
		console.log(action);

		let Q: Questionnaire = JSON.parse(JSON.stringify(action));
		let flatQ = flattenQuestionnaire(Q);
		Q = majConditionAffichageQuestion(Q, flatQ);

		Q.pages.forEach((p, pix) => {
			p.questions.forEach((q, qix) => {
				if (q.condition_affichage != null) {
					q.condition_affichage = testConditionAfichageRemplies(q.condition_affichage);
					q.condition_affichage["affichable"]=true;
					q.condition_affichage["groupe"].forEach(g=>{
						if(!g.groupeIsTrue){
							q.condition_affichage["affichable"]=false;
						}
					});
					// console.log(q.condition_affichage);
				}
			});
		});

		return Q;
	}),

	on(QuestionnaireAction.updateQuestionnaire, (state: Questionnaire, action) => {
		// console.log("on(QuestionnaireAction.updateQuestionnaire");
	// on(QuestionnaireAction.updateQuestionnaire, (state: Questionnaire, action: { questionnaire: Questionnaire }) => {
		let Q: Questionnaire = JSON.parse(JSON.stringify(state));
		let flatQ = flattenQuestionnaire(Q);

		Q = majConditionAffichageQuestion(Q, flatQ);
		Q.pages.forEach((p, pix) => {
			p.questions.forEach((q, qix) => {
				if (q.condition_affichage != null) {
					q.condition_affichage = testConditionAfichageRemplies(q.condition_affichage);
					q.condition_affichage["affichable"]=true;
					q.condition_affichage["groupe"].forEach(g=>{
						if(!g.groupeIsTrue){
							q.condition_affichage["affichable"]=false;
						}
					});
					// console.log(q.condition_affichage);
				}
			});
		});

		return Q;
	}),

	on(QuestionnaireAction.updateQuestionnaireRadio, (state, action) => {


		// let Q: Questionnaire = JSON.parse(JSON.stringify(state));

		// state.pages.forEach((p, i) => {
		// 	p.questions.forEach((q, j) => {
		// 		if (q.id_question == action.qid) {
		// 			if (q.repondu.length == 1) {
		// 				Q.pages[i].questions[j].repondu[0].reponse = action.reponse;
		// 			}
		// 		}
		// 	});
		// });
		
		// console.log("on(QuestionnaireAction.updateQuestionnaireRadio",Q);
		// return Q;
		return state
	}),

	on(QuestionnaireAction.updateQuestionnaireSlider, (state, action) => {
		// let Q: Questionnaire = JSON.parse(JSON.stringify(state));

		// state.pages.forEach((p, i) => {
		// 	p.questions.forEach((q, j) => {
		// 		if (q.id_question == action.qid) {
		// 			if (q.repondu.length == 1) {
		// 				Q.pages[i].questions[j].repondu[0].reponse = action.reponse;
		// 			}
		// 		}
		// 	});
		// });
		// return Q;

		return state;
	}),

	on(QuestionnaireAction.updateQuestionnaireInput, (state, action) => {
		// let Q: Questionnaire = JSON.parse(JSON.stringify(state));

		// state.pages.forEach((p, i) => {
		// 	p.questions.forEach((q, j) => {
		// 		if (q.id_question == action.qid) {
		// 			if (q.repondu.length == 1) {
		// 				Q.pages[i].questions[j].repondu[0].reponse = action.reponse;
		// 			}
		// 		}
		// 	});
		// });
		// return Q;

		return state;
	}),

	on(QuestionnaireAction.updateQuestionnaireCheck, (state, action) => {
		let Q: Questionnaire = JSON.parse(JSON.stringify(state));

		state.pages.forEach((p, i) => {
			p.questions.forEach((q, j) => {
				if (q.id_question == action.qid) {
					if (action.checked) {
						Q.pages[i].questions[j].repondu.push({
							id_reponse: null,
							reponse: action.reponse,
							saisie: "",
						});
					} else {
						q.repondu.forEach((re, ix) => {
							if (re.reponse == action.reponse) {
								Q.pages[i].questions[j].repondu.splice(ix, 1);
							}
						});
					}
				}
			});
		});

		return Q;
	})
);

export function testConditionAfichageRemplies(conditions) {
	let operateur = conditions.operateur;
	
	conditions.groupe.forEach((g, gix) => {
		const ope = g.ope;
		
		if (ope == "||") {
			g.groupeIsTrue = false;
			g.con.forEach((c, cix) => {
				if (c.r) {
					 g.groupeIsTrue = true;
					 
				}
			});
		}else if (ope == "&&") {
			g.groupeIsTrue = true;
			g.con.forEach((c, cix) => {
				if (!c.r) {
					g.groupeIsTrue = false;
					
				}
			});
		}else{ // par defaut c'est du &&...
			g.groupeIsTrue = true;
			g.con.forEach((c, cix) => {
				if (!c.r) {
					g.groupeIsTrue = false;
				}
			});
		}
		conditions.groupe[gix]=g;
		
	});
	return conditions;
}

/**
 *
 * @param Q
 * @param flatQuestions
 * @returns
 */
export function majConditionAffichageQuestion(Q: Questionnaire, flatQuestions) {
	Q.pages.forEach((p, i) => {
		p.questions.forEach((q, j) => {
			// met à jour les conditions d'affichage
			if (q.condition_affichage != null) {
				let conAff = JSON.parse(JSON.stringify(q.condition_affichage));
				conAff = parseConditions(conAff, flatQuestions);

				Q.pages[i].questions[j].condition_affichage = conAff;
			}
		});
	});

	return Q;
}

/**
 *
 * @param condition conditions pour qu'une question soit affichee
 * @param questionsFlat toutes les questions(et leurs reponses) applaties, pour ne pas avoir de LOOP à faire
 * @returns
 */
export function parseConditions(condition, questionsFlat) {
	let operateur = condition.operateur;
	condition.groupe.forEach((c, i) => {
		// pour chaque groupe de conditions

		const operateur = c.ope;

		// pour chaque conditions du groupe
		c.con.forEach((co, k) => {
			// on cherche parmis les réponses de la question conditionnante
			let iof = questionsFlat[co.qid].repondu
				.map((e) => {
					return e.reponse;
				})
				.indexOf(co.v);

			if (iof >= 0) {
				// on y a répondu, on peut les comparer (==, >=, != ...)
				condition.groupe[i].con[k].r = operatorSwitchResult(
					co.c,
					co.v,
					questionsFlat[co.qid].repondu[iof].reponse
				);
			} else {
				// on y a pas répondu
				condition.groupe[i].con[k].r = false;
			}
		});
	});
	return condition;
}
/**
 *
 * @param operator
 * @param v1
 * @param v2
 * @returns
 */
export function operatorSwitchResult(operator, v1, v2) {
	// console.log(operator,v1,v2);
	switch (operator) {
		case "==":
			return v1 == v2;
		case "<":
			return v1 < v2;
		case "<=":
			return v1 <= v2;
		case ">":
			return v1 > v2;
		case ">=":
			return v1 >= v2;
		case "!=":
			return v1 != v2;
	}
}

/**
 *
 * @param questionnaire
 * @returns
 */
export function flattenQuestionnaire(questionnaire: Questionnaire) {
	let questionsFlat: any = {};
	for (const [pix, p] of Object.entries(questionnaire.pages)) {
		p.questions.forEach((q, qix) => {
			questionsFlat[q.id_question] = q;
		});
	}

	return questionsFlat;
}

/**
 *
 * @param state
 * @param action
 * @returns
 */
export function reducer(state: Questionnaire | undefined, action: Action): any {
	return questionnaireReducer(state, action);
}
